import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface UserAvatarProps {
  name?: string | null;
  avatarUrl?: string | null;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeClasses = {
  xs: 'h-6 w-6 text-[10px]',
  sm: 'h-7 w-7 text-xs',
  md: 'h-8 w-8 text-sm',
  lg: 'h-10 w-10 text-base',
  xl: 'h-16 w-16 text-xl',
};

export function UserAvatar({ name, avatarUrl, size = 'sm', className = '' }: UserAvatarProps) {
  const { t } = useTranslation();
  const [imgError, setImgError] = useState(false);
  const initial = name?.charAt(0)?.toUpperCase() ?? '?';
  const sizes = sizeClasses[size];

  if (avatarUrl && !imgError) {
    return (
      <img
        src={avatarUrl}
        alt={name ?? t('web:common.user')}
        onError={() => setImgError(true)}
        className={`${sizes} rounded-full object-cover ring-2 ring-surface-primary ${className}`}
      />
    );
  }

  return (
    <div
      className={`flex items-center justify-center rounded-full bg-surface-inset font-medium text-text-secondary ring-2 ring-surface-primary ${sizes} ${className}`}
      title={name ?? undefined}
    >
      {initial}
    </div>
  );
}
